import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            关于51吃瓜官网的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqItems.map((item, idx) => (
            <details
              key={idx}
              className="group bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 md:p-6 list-none">
                <h3 className="text-base md:text-lg font-heading text-foreground-800 pr-4">
                  {item.q}
                </h3>
                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-background-100 flex items-center justify-center group-open:bg-primary-100 transition-colors">
                  <i className="ri-arrow-down-s-line text-foreground-600 group-open:rotate-180 transition-transform"></i>
                </span>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm text-foreground-500 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}